import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";

const CONSENT_KEY = "lux_pension_cookie_consent";

const setPosthogConsent = (accepted) => {
  try {
    const ph = typeof window !== "undefined" ? window.posthog : null;
    if (!ph) return;
    if (accepted) ph.opt_in_capturing?.();
    else { ph.opt_out_capturing?.(); ph.reset?.(); }
  } catch (e) { console.error("posthog consent error", e); }
};

const CookieBanner = () => {
  const { lang } = useApp();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) {
      // No decision yet — opt out by default until consent is given.
      setPosthogConsent(false);
      setVisible(true);
    } else {
      setPosthogConsent(stored === "accepted");
    }
  }, []);

  const decide = (accepted) => {
    localStorage.setItem(CONSENT_KEY, accepted ? "accepted" : "rejected");
    setPosthogConsent(accepted);
    setVisible(false);
  };

  if (!visible) return null;

  const t = {
    fr: {
      title: "Cookies & analyse d'audience",
      body: "Nous utilisons un cookie essentiel pour la connexion (httpOnly) et un cookie d'analyse anonyme (PostHog) pour mesurer l'audience. Aucune donnée n'est vendue à des tiers.",
      accept: "Accepter",
      reject: "Refuser",
      more: "Politique de confidentialité",
    },
    en: {
      title: "Cookies & analytics",
      body: "We use one essential cookie for sign-in (httpOnly) and one anonymous analytics cookie (PostHog) to measure traffic. No data is ever sold.",
      accept: "Accept",
      reject: "Reject",
      more: "Privacy policy",
    },
    de: {
      title: "Cookies & Analyse",
      body: "Wir verwenden einen wesentlichen Cookie für die Anmeldung (httpOnly) und einen anonymen Analyse-Cookie (PostHog). Keine Daten werden verkauft.",
      accept: "Akzeptieren",
      reject: "Ablehnen",
      more: "Datenschutzerklärung",
    },
  }[lang];

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-slate-200 bg-white shadow-[0_-2px_20px_rgba(15,23,42,0.06)]"
      data-testid="cookie-banner" role="dialog" aria-live="polite">
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-5 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex-1">
          <div className="text-[11px] font-mono uppercase tracking-[0.18em] text-slate-500">/ {t.title}</div>
          <p className="text-sm text-slate-700 mt-2 max-w-3xl leading-relaxed">{t.body}</p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <Link to="/privacy" data-testid="cookie-more"
            className="px-4 py-2.5 text-[11px] font-mono uppercase tracking-[0.15em] text-slate-700 hover:text-slate-900 underline underline-offset-4">
            {t.more}
          </Link>
          <button onClick={() => decide(false)} data-testid="cookie-reject"
            className="px-5 py-2.5 text-[11px] font-mono uppercase tracking-[0.15em] bg-white border border-slate-300 text-slate-900 hover:bg-slate-50">
            {t.reject}
          </button>
          <button onClick={() => decide(true)} data-testid="cookie-accept"
            className="px-5 py-2.5 text-[11px] font-mono uppercase tracking-[0.15em] bg-slate-900 text-white hover:bg-slate-800">
            {t.accept}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
